const axios = require('axios');
const _conf = require('./js/_conf');
const shareWhatsAppUrl = 'https://api.whatsapp.com/send'
const config = _conf.env_type == 1 //判断环境
  ?
  {
    //测试环境
    // baseUrl: '//10.29.204.83:8500/', //香港服务器接口地址
    baseUrl: '//uatapi.house730.com.cn/', //香港服务器接口地址
    pcUrl: '//test.house730.com.cn/', //pc端官网
    wapUrl: '//testm.house730.com.cn/', //wap端官网地址
    pcPushUrl: '//uatpush.house730.com.cn/', //pc邮箱验证
    pcPassport: '//testpush.house730.com.cn/', //pc端个人中心地址
    wapPassport: '//testm.house730.com.cn/my/', //wap端个人中心地址
    googleVerify: '//www.recaptcha.net/recaptcha/api.js', //谷歌验证码SDK
    paypalSdkEN: 'https://www.paypal.com/sdk/js?client-id=AcHCQSYeG6565Zw9lpfKIxH8a_QRAhwjHiqa2XtNASinpDJG-WZFqI_q-tetN1xCvDiMvhPDQBDv-qKR&currency=HKD&locale=en_HK', //paypal支付SDK
    paypalSdkCN: 'https://www.paypal.com/sdk/js?client-id=AcHCQSYeG6565Zw9lpfKIxH8a_QRAhwjHiqa2XtNASinpDJG-WZFqI_q-tetN1xCvDiMvhPDQBDv-qKR&currency=HKD&locale=zh_CN', //paypal支付SDK
    paypalSdk: 'https://www.paypal.com/sdk/js?client-id=AcHCQSYeG6565Zw9lpfKIxH8a_QRAhwjHiqa2XtNASinpDJG-WZFqI_q-tetN1xCvDiMvhPDQBDv-qKR&currency=HKD&locale=zh_HK', //paypal支付SDK
    static: '//uatstatic.house730.com.cn/m/'
  } :
  _conf.env_type == 2 ? {
    //预上线环境环境配置
    baseUrl: 'https://uatapi.house730.com.cn/', //香港服务器接口地址
    pcUrl: '//uat.house730.com.cn/', //pc端官网
    wapUrl: '//uatm.house730.com.cn/', //wap端官网地址
    pcPushUrl: '//uatpush.house730.com.cn/', //pc邮箱验证
    pcPassport: '//uatpush.house730.com.cn/', //pc端个人中心地址
    wapPassport: '//uatm.house730.com.cn/my/', //wap端个人中心地址
    googleVerify: '//www.recaptcha.net/recaptcha/api.js', //谷歌验证码SDK
    paypalSdkEN: 'https://www.paypal.com/sdk/js?client-id=AcHCQSYeG6565Zw9lpfKIxH8a_QRAhwjHiqa2XtNASinpDJG-WZFqI_q-tetN1xCvDiMvhPDQBDv-qKR&currency=HKD&locale=en_HK', //paypal支付SDK
    paypalSdkCN: 'https://www.paypal.com/sdk/js?client-id=AcHCQSYeG6565Zw9lpfKIxH8a_QRAhwjHiqa2XtNASinpDJG-WZFqI_q-tetN1xCvDiMvhPDQBDv-qKR&currency=HKD&locale=zh_CN', //paypal支付SDK
    paypalSdk: 'https://www.paypal.com/sdk/js?client-id=AcHCQSYeG6565Zw9lpfKIxH8a_QRAhwjHiqa2XtNASinpDJG-WZFqI_q-tetN1xCvDiMvhPDQBDv-qKR&currency=HKD&locale=zh_HK', //paypal支付SDK
    static: '//uatstatic.house730.com.cn/m/'
  } :
  _conf.env_type == 4 ? {
    //预上线环境环境配置
    baseUrl: '//simapi.house730.com/', //香港服务器接口地址
    pcUrl: '//sim.house730.com/', //pc端官网
    wapUrl: '//simm.house730.com/', //wap端官网地址
    pcPushUrl: '//simpush.house730.com/', //pc邮箱验证
    pcPassport: '//simpush.house730.com/', //pc端个人中心地址
    wapPassport: '//simm.house730.com/my/', //wap端个人中心地址
    googleVerify: '//www.recaptcha.net/recaptcha/api.js', //谷歌验证码SDK
    paypalSdkEN: 'https://www.paypal.com/sdk/js?client-id=AUGVraiRde38KWLBaGvKHlOnNAoMbvmlPp7bn5AXPyM5855hot4qat-MAXiAKWCDM4AlthzuraLSBvTl&currency=HKD&locale=en_HK', //paypal支付SDK
    paypalSdkCN: 'https://www.paypal.com/sdk/js?client-id=AUGVraiRde38KWLBaGvKHlOnNAoMbvmlPp7bn5AXPyM5855hot4qat-MAXiAKWCDM4AlthzuraLSBvTl&currency=HKD&locale=zh_CN', //paypal支付SDK
    paypalSdk: 'https://www.paypal.com/sdk/js?client-id=AUGVraiRde38KWLBaGvKHlOnNAoMbvmlPp7bn5AXPyM5855hot4qat-MAXiAKWCDM4AlthzuraLSBvTl&currency=HKD&locale=zh_HK', //paypal支付SDK
    static: '//uatstatic.house730.com.cn/m/main/sim/'
  } :{
      //线上环境配置
      // pcUrl: '//10.29.205.217:8500/',
      baseUrl: '//api.house730.com/', //香港服务器接口地址
      pcUrl: '//www.house730.com/', //pc端官网
      wapUrl: '//m.house730.com/', //wap端官网地址
      pcPushUrl: '//push.house730.com/', //pc邮箱验证
      pcPassport: '//push.house730.com/', //pc端个人中心地址
      wapPassport: '//m.house730.com/my/', //wap端个人中心地址
      googleVerify: '//www.recaptcha.net/recaptcha/api.js', //谷歌验证码SDK
      paypalSdkEN: 'https://www.paypal.com/sdk/js?client-id=AUGVraiRde38KWLBaGvKHlOnNAoMbvmlPp7bn5AXPyM5855hot4qat-MAXiAKWCDM4AlthzuraLSBvTl&currency=HKD&locale=en_HK', //paypal支付SDK
      paypalSdkCN: 'https://www.paypal.com/sdk/js?client-id=AUGVraiRde38KWLBaGvKHlOnNAoMbvmlPp7bn5AXPyM5855hot4qat-MAXiAKWCDM4AlthzuraLSBvTl&currency=HKD&locale=zh_CN', //paypal支付SDK
      paypalSdk: 'https://www.paypal.com/sdk/js?client-id=AUGVraiRde38KWLBaGvKHlOnNAoMbvmlPp7bn5AXPyM5855hot4qat-MAXiAKWCDM4AlthzuraLSBvTl&currency=HKD&locale=zh_HK', //paypal支付SDK
      static: '//static.house730.com/m/'
    };
export default {
  getLang, //获取默认语言

  // setLang, //更改默认语言

  getCookie, //获取cookie

  setCookie, //写入cookie

  delCookie, //删除cookie

  getApi, //获取api配置

  getTicket, //获取访客gid

  getDictionary, //获取字典

  getAppConfig, //获取app版本号

  getWapConfig, //获取wap版本号

  config, //通用配置

  checkLogin,

  imgResize,

  getGid, //生成GUID

  telValidator, //手机号验证

  passwordValidator, //密码验证

  emailValidator, //邮箱验证

  getSeoText, // URL尾部汉字SEO

  getUserInfo, // 获取用户数据

  checkWebp,

  debounce,

  // emailValidator //邮箱验证
  shareWhatsAppUrl, //whatsapp地址
};

// 防抖函数
function debounce(func, wait) {
  if (process.client) {
    const context = this; // 传给目标函数
    window._timeout ? clearTimeout(window._timeout) : '';
    window._timeout = setTimeout(() => {
      func.apply(context, arguments);
    }, wait);
  }
}

//获取api配置
function getApi () {
  const baseUrl = config.baseUrl;
  return {
    GetUserInfo: `${baseUrl}User/GetUserInfo`, //获取用户信息
    Login: `${baseUrl}User/Login`, //登录
    SyncVisitorCollection: `${baseUrl}User/SyncVisitorCollection`, //登录合并临时收藏数据
    UpdateUser: `${baseUrl}User/UpdateUser`, //修改用户信息
    LoginOut: `${baseUrl}User/LoginOut`, //登出(请求后token失效)
    RegisterUser: `${baseUrl}User/RegisterUser`, //用户注册
    // 第三方账户 登录注册
    RegisterOrLoginThirdAccount: `${baseUrl}ThirdOAuth/RegisterOrLoginThirdAccount`,
    BindThirdAccount: `${baseUrl}ThirdOAuth/BindThirdAccount`, //登录用户绑定第三方账户
    UnbindThirdAccount: `${baseUrl}ThirdOAuth/UnbindThirdAccount`, //登录用户解绑第三方账户
    BindUserPhone: `${baseUrl}User/BindUserPhone`, //首次绑定手机号 发送短信
    SearchDictionaryInfo: `${baseUrl}DictionaryInfo/SearchDictionaryInfo`, //数据字典
    GetPropertySubCategoryNotAllow: `${baseUrl}Property/GetPropertySubCategoryNotAllow`, //子类型组合不可以同时选择
    GetUserFreePropertyAndCheckPublish: `${baseUrl}Property/GetUserFreePropertyAndCheckPublish`, //刊登免费业主盘信息
    UpdateLeaveMessage: `${baseUrl}User/UpdateLeaveMessage`, //更改留言
    ReplyLeaveMessage: `${baseUrl}User/ReplyLeaveMessage`, //回復留言
    DeleteLeaveMessage: `${baseUrl}User/DeleteLeaveMessage`, //刪除留言
    AddLeaveMessage: `${baseUrl}User/AddLeaveMessage`, //添加留言
    SearchLeaveMessage: `${baseUrl}User/SearchLeaveMessage`, //搜索留言(带房源信息)
    SearchCollection: `${baseUrl}User/SearchCollection`, //搜索收藏
    DeleteCollection: `${baseUrl}User/DeleteCollection`, //删除收藏
    SearchGscope: `${baseUrl}DictionaryInfo/SearchGscope`, //搜索板块信息
    QueryEstate: `${baseUrl}Estate/QueryEstate`, //搜索楼盘
    AddProperty: `${baseUrl}Property/AddProperty`, // 新增房源
    UpdateProperty: `${baseUrl}Property/UpdateProperty`, // 修改房源
    DeletePropertyById:`${baseUrl}Property/DeletePropertyById`, // 删除房源
    GetUserGuidanceTip:`${baseUrl}User/GetUserGuidanceTip`,//刊登页是否加引导
    SearchUserPublishProperty: `${baseUrl}Property/SearchUserPublishProperty`, //  搜索房源(带排名,用户中心用)
    GetProperty: `${baseUrl}Property/GetProperty`, // 获取单个房源信息
    RetrievePassword: `${baseUrl}User/RetrievePassword`, // 获取单个房源信息全量
    GetPropertyUserInfoFullById: `${baseUrl}Property/GetPropertyUserInfoFullById`, //根据房源id获取放盘人信息(全量字段)
    UpdatePropertyStatus: `${baseUrl}Property/UpdatePropertyStatus`, // 修改房源状态
    UpdatePropertyShowStatus: `${baseUrl}Property/UpdatePropertyShowStatus`, // 修改房源状态
    RefreshPropertyAndRecommendById: `${baseUrl}Property/RefreshPropertyAndRecommendById`, //刷新房源
    Upload: `${baseUrl}upload`, // 上传文件
    RotateImage: `${baseUrl}Common/RotateImage`, //旋转图片
    VerifyRetrievePasswordKey: `${baseUrl}User/VerifyRetrievePasswordKey`, // 验证找回密码key
    resetPassword: `${baseUrl}User/resetPassword`, // 密码找回-设置密码
    GetRegisterVerifySms: `${baseUrl}User/GetRegisterVerifySms`, // 发送短信验证码
    GetPropertyFullById: `${baseUrl}Property/GetPropertyFullById`, // 获取单个房源信息全量，
    SearchOrderRecord: `${baseUrl}User/SearchOrderRecord`, //搜索订购记录
    PropertyCoinPaymentOrder: `${baseUrl}Order/PropertyCoinPaymentOrder`, //屋币支付.
    CreatePropertyOrder: `${baseUrl}Property/CreatePropertyOrder`, //创建支付订单
    SearchEstateSuggester: `${baseUrl}Estate/SearchEstateSuggester`, // 搜索楼盘联想
    GetEstate: `${baseUrl}Estate/GetEstate`, //根据楼盘id查楼盘信息
    GetStationDuration:`${baseUrl}EstateAroundInfo/GetEstateAroundMinDuration`,//根据楼盘id获取港铁时间
    GetPropertyPlanSearchParameter:`${baseUrl}Property/GetPropertyPlanSearchParameter`,//获取平面图筛选项
    SearchPropertyPlanImage:`${baseUrl}Property/SearchPropertyPlanImage`,//获取平面图
    SendUserVerifyInfo: `${baseUrl}User/SendUserVerifyInfo`, //发送验证邮件
    VerifyRegisterKey: `${baseUrl}User/VerifyRegisterKey`, // 验证注册的key
    SearchPropertyPriceSet: `${baseUrl}DictionaryInfo/SearchPropertyPriceSet`, // 搜索房源服务价格
    CreatePaypalOrder: `${baseUrl}Order/CreatePaypalOrder`, //创建paypal订单，并返回订单id
    CreatePayDollarOrder:`${baseUrl}Order/CreatePayDollarOrder`,//创建paydollar订单，并返回订单id
    CreatePayDollarOrderCLientPay:`${baseUrl}Order/CreatePayDollarOrderCLientPay`,
    CapturePaypalOrder: `${baseUrl}Order/CapturePaypalOrder`, //用户批准付款后回调
    SearchPropertyCoinSet: `${baseUrl}DictionaryInfo/SearchPropertyCoinSet`, //搜索屋币信息
    GetRecaptcha: `${baseUrl}Common/GetRecaptcha`, //获取验证码
    SendCaptchaByRecaptcha: `${baseUrl}Common/SendCaptchaByRecaptcha`, //快速登录页面验证码验证
    AddPropertyCoinOrder: `${baseUrl}User/AddPropertyCoinOrder`, //添加屋币订单
    GetOrderRecord: `${baseUrl}User/GetOrderRecord`, //根据id获取订单信息
    RegisterVerifySms: `${baseUrl}User/RegisterVerifySms`, // 发送短信验证码
    GetBankTransferPaymentOrderHelp: `${baseUrl}Order/GetBankTransferPaymentOrderHelp`, //获取银行转账支付指南邮件
    GetAppConfig: `${baseUrl}AppConfig/GetAppConfig`, //获取app配置
    GetWapConfig: `${baseUrl}AppConfig/GetWapConfig`, //获取wap配置
    AddCollection: `${baseUrl}User/AddCollection`,
    GetGscope: `${baseUrl}DictionaryInfo/GetGscope`,
    GetKeyword: `${baseUrl}Common/GetKeyword`, //获取敏感词
    UpdateUserPassword: `${baseUrl}User/UpdateUserPassword`, //修改密码
    PreBindEmail: `${baseUrl}User/PreBindEmail`, //绑定邮箱--发送绑定邮件
    BindEmail: `${baseUrl}User/BindEmail`, //绑定邮件
    // CapturePaypalOrder: `${baseUrl}Order/CapturePaypalOrder` //用户批准付款后回调
    // User
    GetUserSubscribeEmailByPhone:`${baseUrl}User/GetUserSubscribeEmailByPhone`,//注册页获取用户订阅新闻邮箱
    LoginByCaptcha: `${baseUrl}User/LoginByCaptcha`, //快捷登入
    LoginByPassword: `${baseUrl}User/LoginByPassword`, //邮箱/手机密码登入
    SendCaptcha: `${baseUrl}Common/SendCaptcha`, //邮箱/手机密码登入 （已废弃）
    RetrievePasswordByPhone: `${baseUrl}User/RetrievePasswordByPhone`, //找回密码(手机)
    RetrievePasswordByEmail: `${baseUrl}User/RetrievePasswordByEmail`, //找回密码(邮箱)
    VerifyRetrievePasswordKey: `${baseUrl}User/VerifyRetrievePasswordKey`, //验证找回密码的key是否有效
    ResetPassword: `${baseUrl}User/ResetPassword`, //找回密码--更改密码接口
    SendSms: `${baseUrl}Common/SendSms`, //邮箱/手机密码登入
    PreModifyPhone: `${baseUrl}User/PreModifyPhone`, //修改電話 老電話驗證
    ModifyPhone: `${baseUrl}User/ModifyPhone`, //修改電話 新電話驗證
    IsAllowPasswordLogin: `${baseUrl}User/IsAllowPasswordLogin`, //修改電話 新電話驗證
    GetCommonWord:`${baseUrl}Common/GetCommonWord`,//常用詞匯獲取
    GetBusinessCommonWord:`${baseUrl}Common/GetBusinessCommonWord`,//工商常用詞匯獲取
    GetServicesCommonWord:`${baseUrl}Common/GetServicesCommonWord`,//工商常用詞匯獲取
    CloseOrder:`${baseUrl}Order/CloseOrder`,// 关闭订单
    VerifyPropertyCanRenewal:`${baseUrl}Property/VerifyPropertyCanRenewal`,
    GetPhasesAndBuildingForPublish:`${baseUrl}Estate/GetPhasesAndBuildingForPublish`,
    GetBuildingFloorPublish:`${baseUrl}Estate/GetBuildingFloorPublish`,
    VerifyPropertyInfoIsOld:`${baseUrl}Property/VerifyPropertyInfoIsOld`,
    GetPropertyRenewalInfo:`${baseUrl}Property/GetPropertyRenewalInfo`,
    // 楼盘订阅相关
    GetUserSubscribePushInfo :`${baseUrl}User/GetUserSubscribePushInfo`,
    GetUserSubscribesV2 :`${baseUrl}User/GetUserSubscribesV2`,//获取订阅列表
    QueryProperty :`${baseUrl}Property/QueryProperty`,//查询对应楼盘
    DeleteUserSubscribe :`${baseUrl}User/DeleteUserSubscribe`,//删除订阅
    UpdateUserSubscribePushInfo :`${baseUrl}User/UpdateUserSubscribePushInfo`,//更改订阅推送时间等
    UpdateUserSubscribeSequence :`${baseUrl}User/UpdateUserSubscribeSequence`,//修改订阅顺序
    UpdateUserSubscribeDefault :`${baseUrl}User/UpdateUserSubscribeDefault`,//心水订阅
    GetPropertyUserInfoList :`${baseUrl}Property/GetPropertyUserInfoList`, // 批量获取代理人/联系人信息
  };
}

//获取当前网站语言并设置默认
function getLang () {
  if (Boolean(window._language)) {return window._language;}
  const lang = location.href.indexOf('/en-us') > -1 ? 'en-us' : location.href.indexOf('/zh-cn') > -1 ? 'zh-cn' : 'zh-hk';
  window._language = lang;
  return lang;
}
//设置当前语言
// function setLang(lang = "zh-hk") {
//     localStorage.setItem("_language", lang);
//     window._language = lang;
// }

//获取cookie
function getCookie (name) {
  let arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');

  if ((arr = document.cookie.match(reg))) {return unescape(arr[2]);}
  return null;
}

//写入cookie 不提供失效时间时，cookie默认有效期为2个月
function setCookie (key, value, expires) {
  // console.log(_conf.env_type);
  const date = expires ? new Date(expires * 1000) : new Date();
  // date.setTime(date.getTime());
  date.setTime(date.getTime() + 60);
  // date.setTime(date.getTime() + 60 * 60 * 1000 * 24 * 60);
  document.cookie = `${key}=${value};expires=${date.toGMTString()};path=/;domain=${(_conf.env_type == 4 || _conf.env_type == 3)? 'house730.com' : 'house730.com.cn'};${(_conf.env_type == 4 || _conf.env_type == 3) ? 'secure=true' : ''}`;
  // document.cookie = `${key}=${value};expires=${date.toGMTString()};path=/;domain=${_conf.env_type == 3 ? 'house730.com' : 'house730.com.cn'};${_conf.env_type == 3 ? 'secure=true' : ''}`;
  // document.cookie = `${key}=${value};expires=${date.toGMTString()};path=/`;
}
//删除cookie
function delCookie (key) {
  var date = new Date();
  date.setTime(date.getTime() - 1);
  var delValue = getCookie(key);
  if (Boolean(delValue)) {
    document.cookie = `${key}=${delValue};expires=${date.toGMTString()};path=/;domain=${(_conf.env_type == 4 || _conf.env_type == 3) ? 'house730.com' : 'house730.com.cn'};${(_conf.env_type == 4 || _conf.env_type == 3) ? 'secure=true' : ''}`;
    // document.cookie = `${key}=${delValue};expires=${date.toGMTString()};path=/;domain=${_conf.env_type == 3 ? 'house730.com' : 'house730.com.cn'};${_conf.env_type == 3 ? 'secure=true' : ''}`;
    // document.cookie = `${key}=${delValue};expires=${date.toGMTString()};path=/`;
  }
}

//访客token生成
function getTicket () {
  let gid = GetCookie('Y190cmFja2lk');
  if (gid) {return gid;}

    gid = getGid().replace(/-/g, '');
    setCookie('Y190cmFja2lk', gid);
    return gid;

}

//生成GUID
function getGid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

//获取字典参数
function getDictionary () {
  const lang = getLang();
  const dic = sessionStorage.getItem('RGljdGlvbmFyeQ_' + lang);
  return new Promise((resolve, reject) => {
    dic
      ?
      resolve(JSON.parse(dic)) :
      axios.get(getApi().SearchDictionaryInfo).then(res => {
        let dicData = {};
        if (res.data.code === 0 && res.data.result) {
          console.log(res, '000099878687');
          res.data.result.forEach(r => (dicData[r.itemName] = r));
          sessionStorage.setItem('RGljdGlvbmFyeQ_' + lang, JSON.stringify(dicData));
          resolve(dicData);
        } else {reject();}
      }, reject);
  });
}
// 获取版本号
function getAppConfig (version) {
  const lang = getLang();
  const versionKey = 'config';
  return new Promise((resolve, reject) => {
    axios.get(getApi().GetAppConfig + `?version=${versionKey}`).then(res => {
      if (res.data.code === 0 && res.data.result) {
        version == res.data.result.version ? resolve(true) : resolve(false);
      } else {reject();}
    }, reject);
  });
}

// 获取wap配置
function getWapConfig (key) {
  const lang = getLang();
  return new Promise((resolve, reject) => {
    axios.get(getApi().GetWapConfig + `?key=${key}`).then(res => {
      if (res.data.code === 0 && res.data.result) {
        console.log("res.data.result", res.data.result);
        resolve(res.data.result);
      } else {reject();}
    }, reject);
  });
}

//檢測登錄
function checkLogin () { }

// 图片懒加载
function imgResize (value, type) {
  if (!value && type === 'user') {return '/user-default.png';}
  if (!value) {return '/house-bg.png';}
  const webp = typeof window == 'object' ? checkWebp() : '';
  if (type === 'full') {value = value + '?x-oss-process=style/' + '1080xauto_f' + webp;}
  else if (type === 'company') {value = value + '?x-oss-process=style/' + '360x270_c' + webp;}
  else if (type === 'silde') {value = value + '?x-oss-process=style/' + '720x540_c' + webp;}
  else if (type === 'user') {value = value + '?x-oss-process=style/' + '150xauto_f' + webp;}
  else {value = value + '?x-oss-process=style/' + '640x480_c' + webp;}
  return value;
}

function checkWebp () {
  if (window._webp != undefined) {return window._webp;}
  try {
    if (
      document
        .createElement('canvas')
        .toDataURL('image/webp')
        .indexOf('data:image/webp') == 0
    )
      {window._webp = '.webp';}
    else {window._webp = '';}
  } catch (err) {
    window._webp = '';
  }
  return window._webp || '';
}

/* 验证手机号 */
function telValidator (tel, check = '852') {
  let status = null;
  //0：成功 ，1:手机长度错误 , 2.手机格式错误
  //  let regHg = /^[965]\d{7}$/;
  //  let regCn = /^[1]\d{10}$/;
  let regHg = /^[4,5,6,7,8,9]/;
  let regCn = /^[1]\d{10}$/;
  if (check.length > 2) {
    if (!regHg.test(tel)) {
      status = 2;
    } else if (tel.length != 8) {
      status = 1;
    } else {
      status = 0;
    }
  } else {
    if (!regCn.test(tel)) {
      status = 2;
    } else if (tel.length != 11) {
      status = 1;
    } else {
      status = 0;
    }
  }

  return status;
}
/* 密码验证 */
function passwordValidator (pass) {
  let regPd = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
  let status = null;
  //0:成功 1:失败
  if (regPd.test(pass)) {
    status = 0;
  } else {
    status = 1;
  }
  return status;
}
/* 邮箱验证 */
function emailValidator (email) {
  let regEm = /^[a-zA-Z0-9]+([\.a-zA-Z0-9_-]*)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  let status = null;
  if (regEm.test(email)) {
    //0:成功 , 1:'格式错误'
    status = 0;
  } else {
    status = 1;
  }
  return status;
}

/* URL尾部添加中文 */
function getSeoText (value, type) {
  /**
   * type
   * 0|undefined：encodeURI转码
   * 1：不转码
   */
  //type:0|undefined 1
  if (value)
    {value = value
      // .replace(/%|'|＇|‘|’|\./g, '-')
      .replace(/%|％|'|‘|’|\.|。|\||｜|\s|「|」/g, '-')
      .replace(/[^a-zA-Z0-9-\u4e00-\u9fa5]/g, '')
      // .replace(/[^\u2E80-\uFE4Fa-zA-Z0-9-\s]|[&${},*?！？＃!#()""]/g, '')
      .trim()
      .replace(/(-)+/g, '-')}
  else {value = '';}
  if (type) {return value}
  return encodeURI(value);
}

/* 获取用户数据 */
function getUserInfo () {
  return new Promise((resolve, reject) => {
    axios.get(getApi().GetUserInfo).then(res => {
      if (res.data.code === 0 && res.data.result) {
        let userInfo = res.data.result;
        resolve (userInfo)
      } else {reject();}
    }, reject);
  });
}







